import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { ReactComponent as SearchIcon } from '../../../assets/icons/searchIcon.svg';
import styles from './SearchInput.module.scss';
import cn from 'classnames';
const SearchInput = ({ onChange, placeholder, className, onFocus, onBlur, value }) => {
    return (_jsx("div", Object.assign({ className: cn(className, styles.wrapper) }, { children: _jsxs("div", Object.assign({ className: cn(styles.element, 'd-flex align-items-center') }, { children: [_jsx(SearchIcon, {}), _jsx("input", { placeholder: placeholder, onChange: onChange, onFocus: onFocus, onBlur: onBlur, value: value })] })) })));
};
export default SearchInput;
